import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AsYouType, CountryCode, getCountryCallingCode } from 'libphonenumber-js';
import { CityService } from '../../services/city.service';
import { ContactService } from '../../services/contact.service';
import { Contact, ContactTitle, Country } from '../../models/models';

@Component({
    selector: 'contact-quick-edit',
    templateUrl: './contact-quick-edit.component.html',
    standalone: false
})
export class ContactQuickEdit implements OnChanges {
    @Input() contactID: number = 0;
    @Input() contactType: string = "";
    @Output() onRefreshContact = new EventEmitter<any>();

    public contact: Contact = {} as Contact;
    public originalContact: Contact = {} as Contact;
    public contactTitleList: ContactTitle[] = [];
    public countryList: Country[] = [];
    public countryCode: string = "US";
    private usPhoneMask: string = "+1 (999) 000-0000";
    private mexicoPhoneMask: string = "52-999-999-9999";
    public phoneMask: string = "+1 (999) 000-0000";
    public cellMask: string = "+1 (999) 000-0000";
    public faxMask: string = "+1 (999) 000-0000";
    public isLoading: boolean = false;    

    constructor(private cityService: CityService, private contactService: ContactService) {
    }

    ngOnInit() {
        this.cityService.getCountriesWithActivePhone().subscribe(resultC => {
            this.countryList = resultC.resultCollection;

            this.contactService.getContactByID(this.contactID).subscribe(result => {
                this.contact = result.resultCollection[0];
                this.originalContact = Object.assign({}, this.contact);
                //if (this.contact.phone != null && this.contact.phone.length > 10 || this.contact.cell != null && this.contact.cell.length > 10) {
                //    this.countryCode = "MX";
                //    this.initValues();
                //}
                if (this.contact.phoneCountryID > 0) {
                    this.getPhoneMask(this.contact.phoneCountryID, 'phone');
                }
                if (this.contact.cellCountryID > 0) {
                    this.getPhoneMask(this.contact.cellCountryID, 'cell');
                }
                this.getContactTitles();
                //console.log("ngOnInit", this.contactType, this.contact);
            });
        });
    }

    ngOnChanges() {
        //console.log("ngOnChanges", this.contact);
    }

    private initValues() {
        //if (this.countryCode == "MX") {
        //    this.phoneMask = this.mexicoPhoneMask;
        //}
        //else {
        //    this.phoneMask = this.usPhoneMask;
        //}
    }

    private getContactTitles() {
        this.contactService.getContactTitles().subscribe(result => {
            this.contactTitleList = result.resultCollection;
            if (this.contactType != "") {
                this.contactTitleList = this.contactTitleList.filter(t => t.contactType.toLocaleLowerCase() == this.contactType.toLocaleLowerCase());
            }
            else {
                this.contactTitleList = this.contactTitleList.filter(t => t.contactType.toLocaleLowerCase() == this.contact.contactType.toLocaleLowerCase());
            }
        });
    }

    public phoneCountryChange(evt: any, type: string) {
        var countryID;
        if (!isNaN(evt)) {
            countryID = parseInt(evt);
        }
        else if (evt != null && evt != "" && evt.target) {
            countryID = evt.target.value;
        }
        else {
            return;
        }
        if (type == "cell") {
            this.contact.cell = "";
        }
        else if (type == "phone") {
            this.contact.phone = "";
        }
        this.getPhoneMask(countryID, type);
    }

    private getPhoneMask(countryID: number, type: string) {
        var country = this.countryList.find(t => t.countryId == countryID) as Country;
        var mask = this.usPhoneMask;
        if (country.abbrev.trimEnd() == "MX") {
            mask = this.mexicoPhoneMask;
        }
        if (type == "cell") {
            this.cellMask = mask;
        }
        else if (type == "phone") {
            this.phoneMask = mask;
        }
    }

    public saveContact() {
        this.isLoading = true;

        if (this.contact.phoneCountryID > 0) {
            if (this.contact.phone != null && this.contact.phone != "") {
                var phoneCountry = this.countryList.find(t => t.countryId == this.contact.phoneCountryID)!;
                var phoneType = new AsYouType(phoneCountry.abbrev.trim() as CountryCode);
                phoneType.input(this.contact.phone);
                var phoneNum = phoneType.getNumber();
                if (phoneNum != undefined && phoneNum != null) {
                    this.contact.phone = phoneType.getNumber()!.countryCallingCode + phoneType.getNumber()!.nationalNumber;
                }
            }
        }
        if (this.contact.cellCountryID > 0) {
            if (this.contact.cell != null && this.contact.cell != "") {
                var cellCountry = this.countryList.find(t => t.countryId == this.contact.cellCountryID)!;
                var cellType = new AsYouType(cellCountry.abbrev.trim() as CountryCode);
                cellType.input(this.contact.cell);
                var cellNum = cellType.getNumber();
                if (cellNum != undefined && cellNum != null) {
                    this.contact.cell = cellType.getNumber()!.countryCallingCode + cellType.getNumber()!.nationalNumber;
                }
            }
        }

        this.contactService.saveContact(this.contact).subscribe(result => {
            this.isLoading = false;
            if (result.contactID > 0) {
                //this.getContacts();
                this.onRefreshContact.emit(result.contactID);
            } else {
                alert('Failed to save Contact');
            }

            this.contact = {} as Contact;
        });
    }

    public cancelContact() {
        this.onRefreshContact.emit();
    }
}
